import './assets/scss/general.scss';
import { lazy, Suspense } from 'react';
import { Routes, BrowserRouter as Router, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import CustomerManagement from './screens/Customers/CustomerManagement';
import ProtectedRoute from './helpers/ProtectedRoute';
import UserContext from './contexts/UserContext';
import Layout from './layouts/Layout';
import { LinearProgress } from '@mui/material';
import { AlertDialogProvider } from './contexts/AlertDialogContext';

// importing screens
const Login = lazy(() => import('./screens/Login'));
const Changepassword = lazy(() => import('./screens/Changepassword'));
const AdminPanel = lazy(() => import('./screens/AdminPanel'));
const Employees = lazy(() => import('./screens/Employees/Employees'));
const CreateEmployee = lazy(() => import('./screens/Employees/CreateEmployee'));
const EmployeeProfile = lazy(
  () => import('./screens/Employees/EmployeeProfile'),
);
const Projects = lazy(() => import('./screens/Projects/Projects'));
const SingleProject = lazy(() => import('./screens/Projects/SingleProject'));
const SingleReport = lazy(() => import('./screens/Projects/SingleReport'));
const Trainings = lazy(() => import('./screens/Trainings/Trainings'));
const CarsScreen = lazy(() => import('./screens/Cars/Cars'));
const Contracts = lazy(() => import('./screens/Contracts/Contracts'));
const CreateContract = lazy(() => import('./screens/Contracts/CreateContract'));
const WorkArrangement = lazy(
  () => import('./screens/WorkArrangement/WorkArrangement'),
);
const ErrorScreen = lazy(() => import('./screens/ErrorScreen'));
const InspectorManagement = lazy(
  () => import('./screens/Inspectors/InspectorManagement'),
);
const CompanyManagement = lazy(
  () => import('./screens/Company/CompanyManagement'),
);
const GeneralOptions = lazy(() => import('./screens/GeneralOptions'));
const GlobalSettings = lazy(
  () => import('./screens/Globalsettings/GlobalsettingsManagement'),
);
const WorkDaysManagement = lazy(
  () => import('./screens/WorkDaysManagement/WorkDaysManagement'),
);
function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AlertDialogProvider>
        <div className="App">
          <Router>
            <Routes>
              <Route
                path="/login"
                element={
                  <Suspense fallback={<LinearProgress />}>
                    <Login />
                  </Suspense>
                }
              />
              <Route
                path="/reset-password"
                element={
                  <Suspense fallback={<LinearProgress />}>
                    <Changepassword />
                  </Suspense>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <AdminPanel />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employees"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <Employees />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/create-employee"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CreateEmployee />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/edit-employee/:uuid/:tab"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CreateEmployee />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employees/:uuid"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <EmployeeProfile />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <Projects />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects/:project_uuid"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <SingleProject />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects/:project_uuid/:report_uuid"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <SingleReport />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trainings"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <Trainings />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer-management"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CustomerManagement />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inspectors"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <InspectorManagement />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/company"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CompanyManagement />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cars"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CarsScreen />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contracts"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <Contracts />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-contract"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CreateContract />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-contract/:uuid"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <CreateContract />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/work-arrangement"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <WorkArrangement />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/general-options"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <GeneralOptions />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/global-settings"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <GlobalSettings />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/work-days-management"
                element={
                  <ProtectedRoute>
                    <Suspense fallback={<LinearProgress />}>
                      <Layout>
                        <WorkDaysManagement />
                      </Layout>
                    </Suspense>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<ErrorScreen />} />
            </Routes>
          </Router>
        </div>
      </AlertDialogProvider>
    </QueryClientProvider>
  );
}

export default App;
